import { ActionIcon, Group, Stack, Text, Title, Tooltip } from '@mantine/core'
import { IconRefresh } from '@tabler/icons-react'
import { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  subtitle?: string
  onRefresh?: () => void
  isLoading?: boolean
  actions?: ReactNode
}

export function PageHeader({ title, subtitle, onRefresh, isLoading, actions }: PageHeaderProps) {
  return (
    <Group justify="space-between" align="flex-start">
      <Stack gap={4}>
        <Title order={2}>{title}</Title>
        {subtitle && <Text size="sm" c="dimmed">{subtitle}</Text>}
      </Stack>
      <Group gap="sm">
        {actions}
        {onRefresh && (
          <Tooltip label="Refresh data">
            <ActionIcon
              variant="light"
              size="lg"
              onClick={onRefresh}
              loading={isLoading}
            >
              <IconRefresh size={18} />
            </ActionIcon>
          </Tooltip>
        )}
      </Group>
    </Group>
  )
}
